import { generator } from '@philips-emr/tws-core/lib/client/event-listener';

const HPMSOnClickTermUse = generator('onClickTerm');
const HPMSOnClickWarning = generator('onClickWarning');
const HPMSOnSubmitTermUse = generator('onSubmitTermUse');

export {
  HPMSOnClickTermUse,
  HPMSOnClickWarning,
  HPMSOnSubmitTermUse,
};
